import { BREAK, DRIVE, PAID, scheduleStatuses, SERVICE, SICK_TIME, STAFF, UNAVAILABLE, UNPAID } from '../../constants';
import {
    ApptAddressType,
    convertHours,
    ErrorText,
    formatAMPMNeW,
    goalDataTypeEnums,
    Images,
    isNotEmpty,
    PermissionList,
    renderDate,
    renderGoalTypes,
    RolePermission,
    TimeIsGreat,
} from 'utils';
import React from 'react';
import { scheduleModalsStyle } from './styles';
import { EditWithIcon, LinkRow, LocalDateRow, NonBillable, SimpleTooltip, SkillCard, TextRow } from 'components';
import moment from 'moment/moment';
import axios from 'axios';
import { UnitHour } from '../../../../components/table/tableRows';
import { getCurrentText } from '../constants';
import { NO_PRIOR } from '../../../../utils/enumValues';
import { renderSessionAverage } from '../../../client/clientSingle/clientClinical/goals/goalCharts/constants';

export function getDynamicContent(content, info, type) {
    const staticText = content === 'TITLE' ? '' : content === 'SUBTITLE' ? ', please fulfill the below fields.' : '';

    const dynamicText = content === 'TITLE' ? (info ? 'Edit ' : 'Add') : content === 'SUBTITLE' ? (info ? 'To edit the' : 'To add a') : '';

    switch (type) {
        case PAID:
            return `${dynamicText} Paid Time Off${staticText}`;
        case STAFF:
            return `${dynamicText} Staff Appointment${staticText}`;
        case BREAK:
            return `${dynamicText} Break${staticText}`;
        case DRIVE:
            return `${dynamicText} Drive${staticText}`;
        case SERVICE:
            return `${dynamicText} Service Appointment${staticText}`;
        case UNPAID:
            return `${dynamicText} Unpaid Time Off${staticText}`;
        case SICK_TIME:
            return `${dynamicText} Sick Time ${staticText}`;
        default:
            return '';
    }
}

export function getDynamicTitle(content, info, type) {
    const dynamicText = content === 'TITLE' ? (info ? 'Edit ' : 'Add') : content === 'SUBTITLE' ? (info ? 'To edit the' : 'To add a') : '';

    switch (type) {
        case PAID:
            return `${dynamicText} Paid Time Off Appointment`;
        case STAFF:
            return `${dynamicText} Staff Appointment`;
        case BREAK:
            return `${dynamicText} Break Appointment`;
        case DRIVE:
            return `${dynamicText} Drive Appointment`;
        case SERVICE:
            return `${dynamicText} Service Appointment`;
        case UNPAID:
            return `${dynamicText} Unpaid Time Off Appointment`;
        case SICK_TIME:
            return `${dynamicText} Sick Time Appointment`;
        case UNAVAILABLE:
            return `${dynamicText} Block Time (Unavailable)`;
        default:
            return '';
    }
}

export const renderTimes = (item) => {
    return item?.slice(11, 16);
};

export const renderUnitSize = (inputs, currentAuthorization, notFixed) => {
    if (inputs?.startTime && inputs?.endTime && currentAuthorization?.service?.unitSize) {
        const startMinutes = inputs?.startTime && timeToMinutes(inputs?.startTime);
        const endMinutes = inputs?.endTime && timeToMinutes(inputs?.endTime);
        const currentUnits = (endMinutes - startMinutes) / currentAuthorization?.service?.unitSize;
        return notFixed ? currentUnits : Number(currentUnits).toFixed(2);
    }
};

export function timeToMinutes(time) {
    if (!time) return 0;

    // If the input is an ISO string, extract the time part
    if (time.includes('T')) {
        const date = new Date(time);
        return date.getUTCHours() * 60 + date.getUTCMinutes(); // Convert UTC time to minutes
    }

    // If the input is a plain "HH:mm" string
    const [hours, minutes] = time.trim().split(':').map(Number);
    return hours * 60 + minutes;
}

export const renderUnitWarnings = (currentService, inputs) => {
    const unitSize = currentService?.service?.unitSize;
    const startMinutes = inputs?.startTime && timeToMinutes(inputs?.startTime);
    const endMinutes = inputs?.endTime && timeToMinutes(inputs?.endTime);
    const maxUnit = currentService?.service?.max;
    const minUnit = currentService?.service?.min;
    const currentApptUnites = (endMinutes - startMinutes) / unitSize;

    return {
        // uniteSizeCorrect: inputs?.startTime && inputs?.endTime && inputs?.authService ? (endMinutes - startMinutes) % unitSize === 0 : true,
        uniteSizeCorrect: inputs?.startTime && inputs?.endTime && currentService ? (endMinutes - startMinutes) % unitSize === 0 : true,
        unitSizeCountIsCorrect:
            // inputs?.startTime && inputs?.endTime && inputs?.authService ?
            inputs?.startTime && inputs?.endTime && currentService ? currentApptUnites <= maxUnit && currentApptUnites >= minUnit : true,
        currentApptUnites: currentApptUnites,
        minUnit: minUnit,
        maxUnit: maxUnit,
        unitSize: unitSize,
    };
};

export const RenderWarnings = ({
    uniteSizeCorrect,
    unitSizeCountIsCorrect,
    unitSize,
    minUnit,
    maxUnit,
    currentApptUnites,
    modalDate,
    warnAuthorization,
    checkAvailableUnits,
    availableUnits,
    // frequencyLimit,
    // currentService,
    // inputs,
    // createMultiple
}) => {
    const classes = scheduleModalsStyle();
    // const checkMultipleFrequency =  createMultiple ? inputs?.endDate : true;

    return (
        <div className={classes.warningBox}>
            {!uniteSizeCorrect && (
                <div className={classes.warning}>
                    <img src={Images.warning} alt="icon" />
                    <div>
                        <p>Duration results in partial units since</p>
                        <p>{`1 unit = ${unitSize} minutes.`}</p>
                    </div>
                </div>
            )}

            {!unitSizeCountIsCorrect && (
                <div className={classes.warning}>
                    <img src={Images.warning} alt="icon" />
                    <div>
                        <p>
                            Selected
                            <span
                                style={{
                                    color: '#DE350B',
                                    fontWeight: 600,
                                    margin: '0 4px',
                                }}
                            >
                                {currentApptUnites.toFixed(2)}
                            </span>
                            units
                            <span>{`
                           is outside the allowed range of  ${minUnit} - ${maxUnit} units, (15-60 mins) for this funding source. 1 unit = ${unitSize} mins.
                            `}</span>
                        </p>
                    </div>
                </div>
            )}

            {checkAvailableUnits < 0 && (
                <div className={classes.warning}>
                    <img src={Images.warning} alt="warning" />
                    <p>
                        Authorized units exceeded, available units are
                        <span style={{ fontWeight: 600, marginLeft: 4 }}>{availableUnits?.toFixed(2)}</span>
                    </p>
                </div>
            )}

            {modalDate?.status === scheduleStatuses?.COMPLETED && (
                <div className={classes.warning}>
                    <img src={Images.warning} alt="icon" />
                    <p>Warning! Since this appointment is already rendered, claims and processed timesheets will not be updated</p>
                </div>
            )}

            {warnAuthorization?.status === 'INACTIVE' && (
                <div className={classes.warning}>
                    <img src={Images.warning} alt="icon" />
                    <p>Authorization is inactive.</p>
                </div>
            )}

            {/*{(inputs?.startDate && inputs?.startTime && inputs?.endTime && inputs?.authService && checkMultipleFrequency) && frequencyLimit === false &&*/}
            {/*    <div>*/}
            {/*        {RolePermission([PermissionList?.APPT_CREATE_FREQUENCY?.code]) ?*/}
            {/*            <div className={classes.warning}>*/}
            {/*                <img src={Images.warning} alt="icon" />*/}
            {/*                <p>You are exceeding the allowed limit of <span style={{*/}
            {/*                    color: '#DE350B',*/}
            {/*                    fontWeight: 600,*/}
            {/*                    margin: '0 4px',*/}
            {/*                }}>{currentService?.frequencyLimit?.limit}</span> units for this service.</p>*/}
            {/*            </div>*/}
            {/*            :*/}
            {/*            <div className={classes.errorWrapper}>*/}
            {/*                <img src={Images.error} alt="icon" />*/}
            {/*                <p>You are exceeding the allowed limit of <span style={{*/}
            {/*                    color: '#DE350B',*/}
            {/*                    fontWeight: 600,*/}
            {/*                    margin: '0 4px',*/}
            {/*                }}>{currentService?.frequencyLimit?.limit}</span> units for this service.</p>*/}
            {/*            </div>*/}
            {/*        }*/}
            {/*    </div>*/}
            {/*}*/}
        </div>
    );
};

export const isStaffCredentialDateGreater = (tb, inputs, createMultiple) => {
    const startDay = inputs?.startDate;
    const endDay = inputs?.endDate || null;
    const tbStartDate = tb?.startDate;
    const tbEndDate = tb?.expireDate;
    let checkIsOut = false;

    if (tbStartDate && tbEndDate && startDay && tb?.checked) {
        const startDate = moment.utc(startDay);
        const endDate = endDay ? moment.utc(endDay) : null;
        const optStartDate = moment.utc(tbStartDate);
        const optEndDate = moment.utc(tbEndDate);

        if (createMultiple && endDate) {
            const isStartInRange = startDate.isBetween(optStartDate, optEndDate, null, '[]');
            const isEndInRange = endDate.isBetween(optStartDate, optEndDate, null, '[]');
            checkIsOut = !(isStartInRange && isEndInRange);
        } else {
            const isStartValid = startDate.isSameOrAfter(optStartDate);
            const isEndValid = startDate.isSameOrBefore(optEndDate);
            checkIsOut = !(isStartValid && isEndValid);
        }
    }

    return checkIsOut;
};
export const apptOverlap = 'appointment overlapping';
export const staffOverlap = 'Staff overlap on appointment';

/**
 * Dot colors for the Service Appointment modal's "Charge Rate" selector. GET
 * /appt/staffs/eligible-charge-rates returns the rates bucketed by billed rate, price descending,
 * each group carrying its position as `groupIndex` — so the color is one per price tier, and green
 * is always the highest tier the staff qualifies for. Rates inside a group share the tier's color.
 */
export const CHARGE_RATE_COLORS = [
    '#12B76A', // green
    '#F79009', // yellow
    '#F04438', // red
];

/**
 * Color for price tier `groupIndex` out of the `groups` tiers the staff qualifies for. The palette
 * is stretched only as far as the tier count, so both ends clamp: one tier is green, two are
 * green/yellow (never red), and three or more are green/yellow then red for every remaining tier.
 */
export const chargeRateColor = (groupIndex, groups) => {
    const lastColorIndex = Math.max(0, Math.min(groups?.length || 1, CHARGE_RATE_COLORS.length) - 1);
    return CHARGE_RATE_COLORS[Math.min(groupIndex || 0, lastColorIndex)];
};

/**
 * Flatten the grouped eligible-charge-rate response to a single list of rates, each tagged with its
 * group's price and color. Used for selection logic (find the default / verify a pick is still
 * eligible) — the UI itself renders the groups nested so each tier keeps its own color.
 */
export const flattenChargeRateGroups = (groups) =>
    (groups || []).flatMap((group) =>
        (group?.chargeRates || []).map((rate) => ({
            ...rate,
            chargeRatePrice: group?.chargeRatePrice,
            color: chargeRateColor(group?.groupIndex, groups),
        })),
    );

export const moreApptHead = [
    { name: '', title: 'ID', custom: false, noSearch: true },
    { name: '', title: 'Start/End Time', noSearch: true, custom: false },
    { name: '', title: 'Staff Member', width: '120px', noSearch: true, custom: false },
    { name: '', title: 'Client', icon: 'date', noSearch: true, custom: false },
    { name: '', title: 'Type', noSearch: true, custom: false },
    // { name: '', title: 'Authorized Serivce', noSearch: true, custom: false },
];

export const moreApptBody = [
    { rowText: (item) => <p style={{ whiteSpace: 'nowrap' }}>{item?.displayId}</p> },
    { rowText: (item) => `${formatAMPMNeW(item?.originalStart)} - ${formatAMPMNeW(item?.originalEnd)}` },
    {
        rowText: (item) => (
            <LinkRow
                name={item?.staff?.fullName}
                href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${item?.staff?.id}` : ''}
                checkPermission={item?.staff?.id ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                textWidth={8}
            />
        ),
    },
    {
        rowText: (item) => (
            <LinkRow
                name={item?.client?.fullName}
                href={RolePermission([PermissionList.CLIENT_READ?.code]) ? `/client/${item?.client?.id}` : ''}
                checkPermission={item?.client?.id ? RolePermission([PermissionList.CLIENT_READ?.code]) : null}
                textWidth={8}
            />
        ),
    },
    {
        rowText: (item) => (
            <div>
                <p style={{ color: '#172B4D' }}>{getCurrentText(item?.type)?.detailText}</p>
                {item?.subject && <TextRow color={'#475467'} name={item?.subject} />}
            </div>
        ),
    },

    // { rowText: (item) => <TextRow name={item?.cptCode ? `${item?.cptCode} ${item?.chargeRateName ? `(${item?.chargeRateName})` : ''}` : '--'} /> },
];

export const checkApptRequires = (modalDate) => {
    return (
        (RolePermission([PermissionList.APPT_SIGNATURE_TOGGLE_MANAGE?.code]) &&
            (modalDate?.status ? modalDate?.status === scheduleStatuses?.PENDING : true)) ||
        (RolePermission([PermissionList.APPT_NOTE_TOGGLE_MANAGE?.code]) &&
            (modalDate?.status ? modalDate?.status === scheduleStatuses?.PENDING : true))
    );
};

const checkTimeComparing = (inputs) => {
    return !!inputs.startTime && !!inputs.endTime && TimeIsGreat(inputs.startTime, inputs.endTime);
};
/**
 * `allowUnassigned` — the user may save a service appt with no staff (an "Unassigned" slot). Staff and
 * Staff Paycode are then optional; the paycode is still required once a staff is picked.
 */
export const checkApptRequiresFields = (inputs, createMultiple, state, allowUnassigned = false) => {
    const staffOk = isNotEmpty(inputs?.staff) || allowUnassigned;
    const payCodeOk = isNotEmpty(inputs?.payCodeType) || (allowUnassigned && !isNotEmpty(inputs?.staff));
    const timeComparingIsValid = !!inputs?.startTime && !!inputs?.endTime && TimeIsGreat(inputs?.startTime, inputs?.endTime);
    const dateComparingIsValid = new Date(inputs?.startDate).getTime() < new Date(inputs?.endDate).getTime();
    const repeat = !!inputs?.repeatCount ? inputs?.repeatCount : !!inputs?.repeatConsecutive ? inputs?.repeatConsecutive : '';

    if (createMultiple) {
        const required =
            isNotEmpty(inputs?.client) &&
            isNotEmpty(inputs?.placeService) &&
            isNotEmpty(inputs?.serviceType) &&
            isNotEmpty(inputs?.authorizedService) &&
            staffOk &&
            payCodeOk &&
            inputs?.startDate &&
            inputs?.endDate &&
            inputs?.startTime &&
            inputs?.endTime &&
            timeComparingIsValid &&
            dateComparingIsValid &&
            (inputs?.mode === 'DAILY'
                ? !!repeat
                : inputs?.mode === 'WEEKLY'
                  ? !!inputs.repeatCountWeek && !!state?.length
                  : !!inputs?.repeatDayMonth && !!inputs.repeatMonth);

        const requiredError = !isNotEmpty(inputs?.client)
            ? 'client'
            : !isNotEmpty(inputs?.placeService)
              ? 'placeService'
              : !isNotEmpty(inputs?.serviceType)
                ? 'serviceType'
                : !isNotEmpty(inputs?.authorizedService)
                  ? 'authorizedService'
                  : !staffOk
                    ? 'staff'
                    : !payCodeOk
                      ? 'payCodeType'
                      : !inputs?.startDate
                        ? 'startDate'
                        : !inputs?.endDate
                          ? 'endDate'
                          : !inputs?.startTime
                            ? 'startTime'
                            : !inputs?.endTime
                              ? 'endTime'
                              : !timeComparingIsValid
                                ? ErrorText.timeError
                                : !dateComparingIsValid
                                  ? ErrorText.dateError
                                  : !repeat
                                    ? 'repeat'
                                    : '';

        if (required) {
            return 'valid';
        } else {
            return requiredError;
        }
    } else {
        const required =
            isNotEmpty(inputs?.client) &&
            isNotEmpty(inputs?.placeService) &&
            isNotEmpty(inputs?.serviceType) &&
            isNotEmpty(inputs?.authorizedService) &&
            staffOk &&
            payCodeOk &&
            inputs?.startDate &&
            inputs?.startTime &&
            inputs?.endTime &&
            timeComparingIsValid;

        const requiredError = !isNotEmpty(inputs?.client)
            ? 'client'
            : !isNotEmpty(inputs?.placeService)
              ? 'placeService'
              : !isNotEmpty(inputs?.serviceType)
                ? 'serviceType'
                : !isNotEmpty(inputs?.authorizedService)
                  ? 'authorizedService'
                  : !staffOk
                    ? 'staff'
                    : !payCodeOk
                      ? 'payCodeType'
                      : !inputs?.startDate
                        ? 'startDate'
                        : !inputs?.startTime
                          ? 'startTime'
                          : !inputs?.endTime
                            ? 'endTime'
                            : !timeComparingIsValid
                              ? ErrorText.timeError
                              : '';

        if (required) {
            return 'valid';
        } else {
            return requiredError;
        }
    }
};

export const checkBreakRequiresFields = (inputs, createMultiple, type, state, multiStaffSelect) => {
    const timeComparingIsValid = !!inputs.startTime && !!inputs.endTime && TimeIsGreat(inputs.startTime, inputs.endTime);
    const dateComparingIsValid = createMultiple
        ? inputs?.startDate && inputs?.endDate && new Date(inputs?.startDate).getTime() < new Date(inputs?.endDate).getTime()
        : inputs?.startDate;
    // true;

    const repeat = !!inputs.repeatCount ? inputs.repeatCount : !!inputs.repeatConsecutive ? inputs.repeatConsecutive : null;

    const checkDateTimeValid = dateComparingIsValid && inputs.startTime && inputs.endTime && timeComparingIsValid;
    const dateTimeError = !inputs?.startDate
        ? 'startDate'
        : createMultiple && !inputs?.endDate
          ? 'endDate'
          : !dateComparingIsValid
            ? ErrorText.dateError
            : !inputs.startTime
              ? 'startTime'
              : !inputs.endTime
                ? 'endTime'
                : !timeComparingIsValid
                  ? ErrorText.timeError
                  : null;

    const checkMultiple = createMultiple
        ? inputs.mode === 'DAILY'
            ? !!repeat
            : inputs.mode === 'WEEKLY'
              ? !!inputs.repeatCountWeek && !!state.length
              : !!inputs.repeatDayMonth && !!inputs.repeatMonth
        : true;

    const checkRepeatError =
        inputs.mode === 'DAILY'
            ? !repeat
                ? 'repeat'
                : ''
            : inputs.mode === 'WEEKLY'
              ? !inputs.repeatCountWeek
                  ? 'repeat'
                  : !state.length
                    ? 'repeat'
                    : ''
              : !inputs.repeatDayMonth
                ? 'repeat'
                : !inputs.repeatMonth
                  ? 'repeat'
                  : '';

    if (type === STAFF) {
        const checkStaffCase = multiStaffSelect ? inputs?.staffs?.length > 0 : isNotEmpty(inputs?.staff);
        if (
            checkStaffCase &&
            isNotEmpty(inputs?.payCodeType) &&
            isNotEmpty(inputs?.staffApptType) &&
            isNotEmpty(inputs?.subject) &&
            checkDateTimeValid &&
            checkMultiple
        ) {
            // if (isNotEmpty(inputs?.staff) && isNotEmpty(inputs?.payCodeType) && isNotEmpty(inputs?.staffApptType) && isNotEmpty(inputs?.subject) && checkDateTimeValid && checkMultiple) {
            return 'valid';
        } else {
            return !checkStaffCase
                ? 'staff'
                : // !inputs?.staff ? 'staff' :
                  !inputs?.payCodeType
                  ? 'payCodeType'
                  : !isNotEmpty(inputs?.staffApptType)
                    ? 'staffApptType'
                    : !isNotEmpty(inputs?.subject)
                      ? 'subject'
                      : dateTimeError
                        ? dateTimeError
                        : !repeat
                          ? 'repeat'
                          : checkRepeatError
                            ? checkRepeatError
                            : '';
        }
    }

    if (type === DRIVE) {
        if (isNotEmpty(inputs?.staff) && isNotEmpty(inputs?.payCodeType) && checkDateTimeValid && checkMultiple) {
            return 'valid';
        } else {
            return !inputs?.staff
                ? 'staff'
                : !inputs?.payCodeType
                  ? 'payCodeType'
                  : dateTimeError
                    ? dateTimeError
                    : !repeat
                      ? 'repeat'
                      : checkRepeatError
                        ? checkRepeatError
                        : '';
        }
    }

    if (type === UNAVAILABLE) {
        if (isNotEmpty(inputs?.staff) && checkDateTimeValid && checkMultiple) {
            return 'valid';
        } else {
            return !inputs?.staff ? 'staff' : dateTimeError ? dateTimeError : !repeat ? 'repeat' : checkRepeatError ? checkRepeatError : '';
        }
    }
    // if (type === STAFF || type === SICK_TIME || type === BREAK || type === DRIVE || type === PAID) {
    //     if (isNotEmpty(inputs?.staff) && isNotEmpty(inputs?.payCodeType) && inputs?.staffApptType && checkDateTimeValid && checkMultiple) {
    //         return 'valid';
    //     } else {
    //         return !inputs?.staff ? 'staff' :
    //             !inputs?.payCodeType ? 'payCodeType' :
    //               !inputs?.staffApptType ? 'staffApptType' :
    //                 dateTimeError ? dateTimeError :
    //                     !repeat ? 'repeat' :
    //                         checkRepeatError ? checkRepeatError :
    //                             '';
    //     }
    // }
    // if (type === UNPAID) {
    //     if (isNotEmpty(inputs?.staff) && checkDateTimeValid && checkMultiple) {
    //         return 'valid';
    //     } else {
    //         return !inputs?.staff ? 'staff' :
    //             dateTimeError ? dateTimeError :
    //                 !repeat ? 'repeat' :
    //                     checkRepeatError ? checkRepeatError :
    //                         '';
    //     }
    // }
};

export const checkDateSelector = (modalDate, createMultiple) => {
    if (modalDate?.template) {
        return !createMultiple;
    } else {
        return true;
    }
};

export const defaultInitialInputs = {
    mode: 'DAILY',
    repeatCountWeek: '1',
    repeatDayMonth: '',
    repeatMonth: '1',
    repeatConsecutive: '',
    repeatCount: '1',
    repeatCountCheckbox: 'repeatCountCheckbox',
};

export const serviceTypeEnum = {
    DIRECT: 'DIRECT',
    INDIRECT: 'INDIRECT',
};

// export const getStartEndAppt = (appts, inputs) => {
//     const apptFilterredList = appts?.appts?.filter((i) => i?.location?._id);
//     console.log(apptFilterredList,'apptFilterredList');
//     console.log(inputs,'inputs');
//     const parseTime = (date, time) => moment.utc(`${date}T${time.trim()}:00Z`);
//     const inputStartTime = parseTime(inputs.startDate, inputs.startTime);
//     const inputEndTime = parseTime(inputs.startDate, inputs.endTime);
//
//     const startAppt = apptFilterredList?.find(appt => {
//         const apptStartTime = moment.utc(appt.startTime);
//         const timeDifferenceInMinutes = inputStartTime.diff(apptStartTime, 'minutes');
//
//         console.log(timeDifferenceInMinutes,'timeDifferenceInMinutes');
//         return (appt.startDate === inputs.startDate && timeDifferenceInMinutes >= -60 && timeDifferenceInMinutes <= 0);
//     });
//     const endAppt = apptFilterredList?.find(appt => {
//         const apptStartTime = moment.utc(appt.startTime);
//         const timeDifferenceInMinutes = inputEndTime.diff(apptStartTime, 'minutes');
//         return (appt.startDate === inputs.startDate && timeDifferenceInMinutes >= -60 && timeDifferenceInMinutes <= 0);
//     });
//
//     const params = {};
//     startAppt ? params.from = startAppt?.location : delete params.from;
//     endAppt ? params.to = endAppt?.location : delete params.to;
//     return params;
// };

export const getStartEndAppt = (appts, inputs) => {
    const apptFilterredList = appts?.appts?.filter((i) => i?.location?._id && i?.startDate === inputs.startDate);

    if (!apptFilterredList?.length) return {};

    const parseTime = (date, time) => moment.utc(`${date}T${time.trim()}:00Z`);

    const inputStartTime = parseTime(inputs.startDate, inputs.startTime);
    const inputEndTime = parseTime(inputs.startDate, inputs.endTime);

    const startAppt = apptFilterredList
        .filter((appt) => {
            const apptStartTime = moment.utc(appt.startTime);
            const diff = inputStartTime.diff(apptStartTime, 'minutes');
            return diff >= 0 && diff <= 60; // within 1 hour before
        })
        .sort((a, b) => moment.utc(b.startTime) - moment.utc(a.startTime))[0];

    const endAppt = apptFilterredList
        .filter((appt) => {
            const apptStartTime = moment.utc(appt.startTime);
            const diff = apptStartTime.diff(inputEndTime, 'minutes');
            return diff >= 0 && diff <= 60;
        })
        .sort((a, b) => moment.utc(a.startTime) - moment.utc(b.startTime))[0];

    const params = {};
    startAppt ? (params.from = startAppt?.location) : delete params.from;
    endAppt ? (params.to = endAppt?.location) : delete params.to;
    // const params = {};
    // if (startAppt) params.from = startAppt.location;
    // if (endAppt) params.to = endAppt.location;

    return params;
};

export const getDestinationFromAddresses = (apptLocations) => {
    const fromRoute = `${apptLocations?.from?.lat},${apptLocations?.from?.lng}`;
    const toRoute = `${apptLocations?.to?.lat},${apptLocations?.to?.lng}`;
    const apiKey = '448b7c0b-9165-43ff-801f-b6f2565a2e24';
    const url = `https://graphhopper.com/api/1/route?point=${fromRoute}&point=${toRoute}&vehicle=car&locale=en&calc_points=true&key=448b7c0b-9165-43ff-801f-b6f2565a2e24`;
    try {
        axios
            .get(url, { calc_points: true, key: apiKey, useBaseUrl: false })
            .then((response) => {
                const data = response.data.paths[0];
                const distanceInMiles = ((data.distance / 1000) * 0.621371).toFixed(2);
                const durationInMinutes = data.time / 60000;
                const days = Math.floor(durationInMinutes / (60 * 24));
                const hours = Math.floor((durationInMinutes % (60 * 24)) / 60);
                const minutes = Math.floor(durationInMinutes % 60);

                return {
                    distance: distanceInMiles,
                    time: `${days ? `${days}d` : ''}${hours ? `${hours}h` : ''}${minutes ? `${minutes}m` : ''}`,
                };
                // setDistanceInformation({
                //     distance: distanceInMiles,
                //     time: `${days ? `${days}d` : ''}${hours ? `${hours}h` : ''}${minutes ? `${minutes}m` : ''}`,
                // });
            })
            .catch((error) => {});
    } catch (error) {
        return {};
    }
};

export const signatureTypeEnums = {
    SIGNATURE: 'SIGNATURE',
    PROVIDER_SIGNATURE: 'PROVIDER_SIGNATURE',
};

/** Who a bulk signature reminder is directed at. Backend currently reminds the
 *  client/guardian only — `reminderType` is forwarded so the API can branch on
 *  it once provider reminders are supported (see docs/modules/scheduling.md). */
export const reminderTargetEnum = {
    CLIENT: 'CLIENT',
    PROVIDER: 'PROVIDER',
};

/** Whose signature a bulk-sign applies. GUARDIAN requires a single client and
 *  names the signer as a client contact (`signor`) or an ad-hoc `otherSigner`. */
export const bulkSignTargetEnum = {
    PROVIDER: 'PROVIDER',
    GUARDIAN: 'GUARDIAN',
};

export const noActivePayCodeMessage = 'No active pay code found for the given date and type.';

export const mergePayCodes = (allPaycodes) => {
    const transformedPayCodes = allPaycodes?.map((item) => ({
        ...item.payCodeTypeId,
        id: item.payCodeTypeId._id,
    }));
    const seen = new Set();
    return transformedPayCodes?.filter((item) => {
        const payCodeId = item._id;
        if (seen.has(payCodeId)) {
            return false;
        }
        seen.add(payCodeId);
        return true;
    });
};

export const ServiceActionLoads = {
    GET_AUTHORIZATION: 'GET_AUTHORIZATION',
    GET_AUTH: 'GET_AUTH',
    GET_ALL_PAY_CODES: 'GET_ALL_PAY_CODES',
    APPOINTMENT_FROM_TEMPLATE: 'APPOINTMENT_FROM_TEMPLATE',
};

export const StaffCredential = ({ currentStaff }) => {
    return (
        <div className="staff-credential-wrapper">
            <div className="credential-title-text-wrapper" style={{ marginBottom: 0 }}>
                <p className="credential-info-title">Credentials:</p>
                <div className="credential-information-body">
                    {currentStaff?.credentials?.length ? (
                        <p>{currentStaff?.credentials?.map((i) => (i?.name ? i?.name : i?.type)).join(', ')}</p>
                    ) : (
                        <p>No Credentials</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export const clientAddresses = (clientItemInfo, clientContacts) => {
    const clientDetailAddresses = clientItemInfo?.addresses?.length
        ? clientItemInfo?.addresses?.map((item) => ({
              name: item?.address?.formattedAddress,
              id: item?.address,
          }))
        : [];
    const clientContactAddresses = clientContacts?.length
        ? clientContacts?.map((item) => ({
              name: item?.address?.formattedAddress,
              id: item?.address,
          }))
        : [];
    return [...clientDetailAddresses, ...clientContactAddresses];
};

/**
 * Flatten the `/appt/addresses` response (client + client contact + staff + office) into the
 * `{ name, id }` shape AddressTypeSelect expects (name = the formatted address, id = the address
 * object). Unlike `clientAddresses`, this includes the assigned staff member's and the org's office
 * addresses, so the location dropdown covers everywhere an appt might be held.
 *
 * Each item also keeps the backend `type` (ApptAddressType) and `refId` (client address / contact /
 * staff / company id) so `default` can be matched by source, not by address text, and `label`
 * (client address name or the client's custom scheduling name) which is saved as `locationLabel`.
 */
export const apptAddressesList = (apptAddresses) => {
    if (!apptAddresses) return [];
    // `bucketType` backs up `entry.type`: an API build that predates `type` still gets its group header.
    const toItems = (entries, bucketType) =>
        (entries || [])
            .filter((entry) => entry?.address?.formattedAddress)
            .map((entry) => {
                const type = entry.type || bucketType;
                return {
                    name: entry.address.formattedAddress,
                    id: entry.address,
                    refId: entry.id,
                    type,
                    label: entry.label || null,
                };
            });
    return [
        ...toItems(apptAddresses.client, ApptAddressType.CLIENT),
        ...toItems(apptAddresses.clientContact, ApptAddressType.CLIENT_CONTACT),
        ...toItems(apptAddresses.staff, ApptAddressType.STAFF),
        ...toItems(apptAddresses.office, ApptAddressType.OFFICE),
    ];
};

/** The list item for `/appt/addresses` → `default` (same `type` + id), or undefined. */
export const findApptAddressItem = (list, entry) =>
    entry ? list?.find((item) => item.type === entry.type && item.refId === entry.id) : undefined;

/** The list item the selected address object came from (options carry the same object as `id`). */
export const findApptAddressByValue = (list, value) =>
    value ? list?.find((item) => item.id === value) || list?.find((item) => item.name === value?.formattedAddress) : undefined;

export const checkServiceDateAvailable = (option, inputs, createMultiple, defaultDates) => {
    const startDay = defaultDates ? (inputs?.startDate ? inputs?.startDate : moment.utc().format('YYYY-MM-DD')) : inputs?.startDate;
    const endDay = defaultDates ? (inputs?.endDate ? inputs?.endDate : moment.utc().format('YYYY-MM-DD')) : inputs?.endDate;
    // const startDay = inputs?.startDate
    // const endDay = inputs?.endDate
    const optionStartDay = option?.startDate;
    const optionEndDay = option?.endDate;
    let checkIsOut = false;

    if (optionStartDay && optionEndDay && startDay) {
        const startDate = moment(startDay);
        const optStartDate = moment(optionStartDay);
        const optEndDate = moment(optionEndDay);

        if (createMultiple && endDay) {
            const endDate = moment(endDay);
            const isStartInRange = startDate.isBetween(optStartDate, optEndDate, null, '[]');
            const isEndInRange = endDate.isBetween(optStartDate, optEndDate, null, '[]');

            checkIsOut = !(isStartInRange && isEndInRange);
        } else {
            const isStartInRange = startDate.isBetween(optStartDate, optEndDate, null, '[]');
            checkIsOut = !isStartInRange;
        }
    }
    return checkIsOut;
};
export const checkServiceDateAvailableColors = (option, inputs) => {
    const startDay = inputs?.startDate ? inputs.startDate : moment.utc().format('YYYY-MM-DD');
    const endDay = inputs?.endDate ? inputs.endDate : startDay;
    const optionStartDay = option?.startDate;
    const optionEndDay = option?.endDate;
    const startDate = moment(startDay);
    const endDate = moment(endDay);
    const optStartDate = moment(optionStartDay);
    const optEndDate = moment(optionEndDay);
    const isStartInRange = startDate.isBetween(optStartDate, optEndDate, null, '[]');
    const isEndInRange = endDate.isBetween(optStartDate, optEndDate, null, '[]');

    if (startDate.isAfter(optEndDate)) {
        return {
            background: 'rgb(254, 243, 242)',
            color: 'rgb(180, 35, 24)',
        };
    } else if (isStartInRange && isEndInRange) {
        return {
            background: 'rgb(236, 253, 243)',
            color: 'rgb(2, 122, 72)',
        };
    } else if (isStartInRange || isEndInRange || endDate.isBefore(optStartDate)) {
        return {
            background: '#FFFAEB',
            color: '#BF602A',
        };
    }

    return {
        background: 'rgb(254, 243, 242)',
        color: 'rgb(180, 35, 24)',
    };
};
export const renderServiceRow = (option, inputs, createMultiple) => {
    let colors = checkServiceDateAvailableColors(option, inputs, createMultiple, true);
    let unitMinutes = option?.availableUnits * option?.service?.unitSize;

    return (
        <div className="space-between">
            <div className="flex-align-center" style={{ gap: 6 }}>
                <div className="option-service-cptCode" style={{ fontWeight: 600 }}>
                    <TextRow
                        name={`${option?.service?.serviceTypeId?.displayCode || ' '} - ${option?.service?.cptCode}`}
                        fontWeight={600}
                        textWidth={7}
                    />
                </div>
                <div className={'flex-align-center'} style={{ maxWidth: 200, width: 'fit-content' }}>
                    (<TextRow name={option?.chargeRates?.map((e) => e?.name).join(', ')} />)
                </div>
                <div className={unitMinutes > 0 ? 'option-service-units' : 'option-service-units-unavailable'}>
                    {option?.availableUnits ? <UnitHour info={option?.availableUnits} size={option?.service?.unitSize} /> : 0}
                </div>
                {option?.billable === false && <NonBillable noText={true} toolText="Non-billable authorization" />}
            </div>


            <div className="flex-align-center">
                <div
                    style={{
                        background: colors?.background,
                        color: colors?.color,
                    }}
                    className="auth-service-option-date"
                >
                    {`${renderDate(option?.startDate, 'MM/DD/YY')} - ${renderDate(option?.endDate, 'MM/DD/YY')}`}
                </div>
                <p className="auth-service-option-name">
                    <TextRow
                        name={option?.authorizationId === NO_PRIOR ? option?.authorizationId : `#${option?.authorizationId}`}
                        textWidth={8}
                    />
                </p>
                <div className="option-payer-wrapper">
                    <img src={Images.businessCenter} alt="businessCenter" />
                    <SimpleTooltip title={<p>{option?.payerName}</p>} placement="top-end">
                        <p style={{ width: '45px' }}>
                            {option?.payerShortName ? option?.payerShortName : `${option?.payerName?.slice(0, 5)}.`}
                            {/*{option?.payerCode ? option?.payerCode : `${option?.payerName?.slice(0, 5)}.`}*/}
                        </p>
                    </SimpleTooltip>
                </div>
            </div>



        </div>
    );
};

export const changeDateTime = (date, time) => {
    const convertedTime = moment.utc(date);
    convertedTime.set({
        hour: time?.slice(0, 2),
        minute: time?.slice(3, 5),
        second: '00',
    });
    return convertedTime.format();
};

export const checkFrequencyValid = (inputs, modalDate, createMultiple, appointmentDates, recur) => {
    if (recur) {
        return !!(inputs?.startDate && inputs?.endDate);
    }
    if (!createMultiple && !modalDate?.id) {
        return !!(inputs?.startDate && inputs?.startTime && inputs?.endTime && inputs?.authorizedService);
        // return !!(inputs?.startDate && inputs?.authorizedService);
    }
    if (createMultiple && !modalDate?.id) {
        const checkIfMultiple = createMultiple ? inputs?.endDate : true;
        return !!(inputs?.startDate && inputs?.startTime && inputs?.endTime && inputs?.authorizedService && checkIfMultiple);
        // return !!(inputs?.startDate && inputs?.authorizedService && checkIfMultiple);
    }
    if (!createMultiple && modalDate?.id) {
        return !!(inputs?.startDate && inputs?.startTime && inputs?.endTime && inputs?.authorizedService);
        // return !!(inputs?.startDate && inputs?.authorizedService);
    }
    if (createMultiple && modalDate?.id) {
        const startDate = appointmentDates?.startDate || inputs?.betweenStartDate;
        const endDate = appointmentDates?.endDate || inputs?.betweenEndDate;
        return !!(startDate && inputs?.startTime && endDate && inputs?.authorizedService);
        // return !!(startDate && endDate && inputs?.authorizedService);
    }
};

export const checkFrequencyParams = (data) => {
    const { params, createMultiple, modalDate, appointmentDates, apptUnits, apptCount, selectedDays } = data;

    const endDate =
        createMultiple && modalDate?.id
            ? params?.betweenEndDate
                ? params?.betweenEndDate
                : appointmentDates?.endDate
            : createMultiple
              ? params?.endDate
              : null;
    const startDate =
        createMultiple && modalDate?.id
            ? params?.betweenStartDate
                ? params?.betweenStartDate
                : appointmentDates?.startDate
            : params?.startDate;

    // Resolve recurrence pattern fields for backend computation
    const isWeekdaysOnly = params?.repeatConsecutive === 'repeatConsecutive';
    const repeatEvery = createMultiple
        ? params?.mode === 'WEEKLY'
            ? +(params?.repeatCountWeek || 1)
            : params?.mode === 'MONTHLY'
              ? +(params?.repeatMonth || 1)
              : isWeekdaysOnly
                ? null
                : +(params?.repeatCount || 1)
        : null;

    const sendParams = {
        // Required
        unitCount: apptUnits,
        authServiceId: params?.authorizedService,
        startDate: moment.utc(startDate).format('YYYY-MM-DD'),
        // Not Required
        endDate: endDate ? moment.utc(endDate).format('YYYY-MM-DD') : null,
        apptCount: modalDate?.id && createMultiple ? 1 : createMultiple ? apptCount : modalDate?.id ? 1 : null,
        templateId: createMultiple && modalDate?.template ? modalDate?.template : null,
        apptId: !createMultiple && modalDate?.id ? modalDate?.id : null,
        // Recurrence pattern (backend computes per-period count from these)
        mode: createMultiple ? params?.mode : null,
        repeatEvery: repeatEvery,
        selectedDays: createMultiple && params?.mode === 'WEEKLY' && selectedDays?.length ? selectedDays.join(',') : null,
        weekdaysOnly: createMultiple && params?.mode === 'DAILY' && isWeekdaysOnly ? 'true' : null,
        repeatDayMonth: createMultiple && params?.mode === 'MONTHLY' ? +(params?.repeatDayMonth || 0) || null : null,
    };

    // sendParams.apptCount = occurrence ? occurrence : 1;
    // if (recur) {
    //     sendParams.startDateTime = changeDateTime(params?.startDate, params?.startTime);
    //     sendParams.endTime = changeDateTime(params?.startDate, params?.endTime);
    //     sendParams.endDate = changeDateTime(params?.endDate, params?.endTime);
    //     sendParams.apptCount = occurrence;
    // }
    // if (!modalDate?.id) {
    //     sendParams.startDateTime = changeDateTime(params?.startDate, params?.startTime);
    //     sendParams.endTime = changeDateTime(params?.startDate, params?.endTime);
    //     sendParams.endDate = createMultiple ? changeDateTime(params?.endDate, params?.endTime) : null;
    //     sendParams.apptCount = createMultiple ? (params?.count ? params?.count : occurrence) : 1;
    // }
    // if (!createMultiple && modalDate?.id) {
    //     sendParams.startDateTime = changeDateTime(params?.startDate, params?.startTime);
    //     sendParams.endTime = changeDateTime(params?.startDate, params?.endTime);
    //     sendParams.endDate = null;
    //     sendParams.apptCount = 1;
    // }
    // if (createMultiple && modalDate?.id) {
    //     const startDate = params?.betweenStartDate ? params?.betweenStartDate : appointmentDates?.startDate;
    //     const endDate = params?.betweenEndDate ? params?.betweenEndDate : appointmentDates?.endDate;
    //     sendParams.templatedId = modalDate?.template;
    //     sendParams.startDateTime = changeDateTime(startDate, params?.startTime);
    //     sendParams.endTime = changeDateTime(startDate, params?.endTime);
    //     sendParams.endDate = changeDateTime(endDate, params?.endTime);
    // }

    return sendParams;
};

export const recurServiceApptDetails = (item) => [
    { title: 'Appt ID:', value: item?.displayId },
    { title: 'Type:', value: getCurrentText(item?.type)?.detailText },
    {
        title: 'Date/Time:',
        value: (
            <div className="flex-align-center" style={{ gap: '8px' }}>
                <p>{moment.utc(item?.startDate).format('MM/DD/YYYY')}</p>
                <p className="schedule-time">{`${formatAMPMNeW(item?.startTime)} - ${formatAMPMNeW(item?.endTime)}`}</p>
            </div>
        ),
    },
    {
        title: 'Staff:',
        link: true,
        value: item?.staff ? (
            <LinkRow
                staff={item?.staff}
                href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${item?.staff?.id}` : ''}
                checkPermission={item?.staff?.id ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                defaultColor={'#172B4D'}
            />
        ) : null,
    },
    {
        title: 'Client:',
        link: true,
        value: item?.client ? (
            <LinkRow
                client={item?.client}
                href={RolePermission([PermissionList.CLIENT_READ?.code]) ? `/client/${item?.client?.id || item?.client?._id}` : ''}
                checkPermission={item?.client ? RolePermission([PermissionList.CLIENT_READ?.code]) : null}
                defaultColor={'#172B4D'}
            />
        ) : null,
    },
    RolePermission([PermissionList.CLIENT_AUTHORIZATION_READ?.code, PermissionList.CLIENT_AUTHORIZATION_MANAGE?.code]) && {
        title: 'Authorization:',
        value: `${item?.authorizedService?.authorizationId},
             ${moment.utc(item?.authorizedService?.startDate).format('MM/DD/YYYY')} -
             ${moment.utc(item?.authorizedService?.endDate).format('MM/DD/YYYY')}
             `,
    },
    {
        title: 'Service:',
        value: `${item?.authorizedService?.service?.cptCode} ${item?.chargeRateName ? `(${item.chargeRateName})` : ''}`,
    },
];
export const recurBreakApptDetails = (item) => [
    { title: 'Appt ID:', value: item?.displayId },
    { title: 'Type:', value: getCurrentText(item?.type)?.detailText },
    {
        title: 'Date/Time:',
        value: (
            <div className="flex-align-center" style={{ gap: '8px' }}>
                <p>{moment.utc(item?.startDate).format('MM/DD/YYYY')}</p>
                <p className="schedule-time">{`${formatAMPMNeW(item?.startTime)} - ${formatAMPMNeW(item?.endTime)}`}</p>
            </div>
        ),
    },
    {
        title: 'Staff:',
        value: item?.staff ? (
            <LinkRow
                staff={item?.staff}
                href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${item?.staff?.id}` : ''}
                checkPermission={item?.staff?.id ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                defaultColor={'#172B4D'}
            />
        ) : null,
        link: true,
    },
];

export const scheduleDataCollectionTableInfo = () => {
    return {
        loadingType: 'GET_APPT_DATA_COLLECTION',
        head: [
            { name: 'goalName', title: 'Goal', width: '15%', noSearch: true },
            { name: 'targetName', title: 'Target', width: '15%', noSearch: true },
            { name: 'type', title: 'Type', width: '10%', custom: false, noSearch: true },
            { name: 'dataType', title: 'Data Methods', width: '20%', custom: false, noSearch: true },
            { name: 'trials', title: 'Trials', width: '10%', custom: false, noSearch: true },
            { name: 'collected', title: 'Collected', width: '15%', custom: false, noSearch: true },
            { name: 'result', title: 'Result', width: '10%', custom: false, noSearch: true },
        ],

        body: (item, key, parent) => {
            const firstTrial = item?.tSummary?.trials?.length > 0 ? item?.tSummary?.trials[0] : {};

            return [
                { value: <TextRow name={item?.goalName} />, width: '15%' },
                { value: <TextRow name={item?.targetName} />, width: '15%' },
                { value: <SkillCard type={item?.type} />, width: '10%' },
                { value: renderGoalTypes(item?.dataType), width: '20%' },
                {
                    // A frequency measure has no trial count — it keeps one trial holding the
                    // whole count, so `numTrials/minTrial` would always read "1/N". The count
                    // itself is already in the Result column.
                    value: (
                        <div>
                            {item?.dataType === goalDataTypeEnums.FREQUENCY
                                ? '--'
                                : `${item?.tSummary?.numTrials}/${item?.minTrial}`}
                        </div>
                    ),
                    width: '10%',
                },
                { value: <LocalDateRow date={firstTrial?.dateCollected} />, width: '15%' },
                {
                    value: <div>{renderSessionAverage({ ...item?.tSummary, data: item?.tSummary?.trialData })}</div>,
                    width: '10%',
                },
            ];
        },

        renderAccordionRow: (i) => i,

        // accordionHead: [
        //     { title: 'Bill ID', width: '8%' },
        //     { title: 'DOS', width: '7%' },
        // ],
        //
        // accordionBody: (i, j, parent) => {
        //     return [
        //         { value: <TextRow name={i?.displayId ? i?.displayId : '--'} />, width: '8%' },
        //         { value: <DateRow date={i?.dos} />, width: '7%' },
        //     ];
        // },

        noDetailsText: 'No Targets yet',
        notYet: {
            height: '250px',
            title: 'You don’t have Sessions yet',
            subTitle: 'Nothing new for now. Enjoy the silence while it lasts',
            image: Images.emptyFolder,
        },
    };
};

export const scheduleDataCollectionNotYet = {
    height: '250px',
    title: 'You don’t have Sessions yet',
    subTitle: 'Nothing new for now. Enjoy the silence while it lasts',
    image: Images.emptyFolder,
};

export const SCHEDULE_DATA_COLLECTION_ACTION_TYPE = 'GET_APPT_DATA_COLLECTION';
